import { Form } from '@/components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Drawer } from '@/ui';
import styled from 'styled-components';

export const StyledContainerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2rem 0 0 1.5rem;
  overflow-x: auto;
`;

export const StyledContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 1.5rem;
`;

export const StyledDrawer = styled(Drawer)`
  &&& .ant-drawer-body {
    overflow: hidden;
  }
`;

export const StyledProductsCountText = styled.div`
  display: flex;
  justify-content: space-between;
  ${pickThemeFontStyles('20', '30', 'NORMAL')};
`;

export const StyledHeaderButtonsWrapper = styled.div`
  display: flex;
  gap: 1rem;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1 auto;
  overflow-y: auto;
  padding-right: 1.5rem;
`;

export const StyledAddProductButton = styled(Button)`
  &&& {
    background: transparent;
    border: none;
    line-height: 1;
    padding: 0;
    width: fit-content;
  }

  &&&:hover {
    background: transparent;
    border: none;
  }
`;

export const StyledAddProductIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${COLORS.CHARCOAL};
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 0.5rem;

  &&& svg {
    fill: ${COLORS.CHARCOAL};
    height: 0.75rem;
    width: 0.75rem;
    transform: rotate(45deg);
  }
`;
